import { render } from "./ManageStatus.vue?vue&type=template&id=15074ecf"
import script from "./ManageStatus.vue?vue&type=script&lang=js"
export * from "./ManageStatus.vue?vue&type=script&lang=js"

import "./ManageStatus.vue?vue&type=style&index=0&id=15074ecf&lang=scss"
script.render = render

export default script